var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row gutter-md desktop-only" }, [
        _c("div", { staticClass: "col-sm-3" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("points", {
                  attrs: {
                    score: _vm.score,
                    score_statement: _vm.user_score_statement,
                    home: true
                  },
                  on: { showStatement: _vm.showStatement }
                })
              ],
              1
            ),
            _vm.showRanking
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("ranking", {
                      on: {
                        seeAll: function($event) {
                          return _vm.seeAll()
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.has_calendar
              ? _c(
                  "div",
                  { staticClass: "col-12 col-12 q-mt-md" },
                  [_c("calendar")],
                  1
                )
              : _vm._e()
          ])
        ]),
        _c("div", { staticClass: "col-sm-9" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _vm.home_banners.length > 0
              ? _c(
                  "div",
                  { staticClass: "col-12 desktop-only" },
                  [
                    _c(
                      "q-carousel",
                      {
                        staticClass: "text-white shadow-3",
                        attrs: { height: "200px", infinite: "", autoplay: "" }
                      },
                      _vm._l(_vm.home_banners, function(banner, index) {
                        return _c("q-carousel-slide", {
                          key: index,
                          staticClass: "cursor-pointer background-slide",
                          attrs: { "img-src": banner.image_desktop },
                          nativeOn: {
                            click: function($event) {
                              return _vm.openBanner(banner)
                            }
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "col-8" }, [
              _c("div", { staticClass: "row" }, [
                _vm.banners_trainings.length > 0
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "q-card",
                          { staticClass: "bg-white" },
                          [
                            _c(
                              "q-card-title",
                              {
                                staticClass: "text-center bg-primary text-white"
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t("next_steps")) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _c("q-card-separator"),
                            _c(
                              "q-card-main",
                              { staticClass: "text-center relative-position" },
                              [
                                _c(
                                  "q-carousel",
                                  {
                                    staticClass: "text-white no-shadow",
                                    attrs: {
                                      height: "350px",
                                      infinite: "",
                                      autoplay: ""
                                    }
                                  },
                                  _vm._l(_vm.banners_trainings, function(
                                    banner,
                                    index
                                  ) {
                                    return _c(
                                      "q-carousel-slide",
                                      {
                                        key: index,
                                        staticClass: "cursor-pointer",
                                        attrs: {
                                          "img-src": banner.image_desktop
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.goToTraining(banner)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "absolute-bottom custom-caption"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "q-headline" },
                                              [_vm._v(_vm._s(banner.title))]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _vm.surveys.length != 0
                      ? _c("surveys", {
                          attrs: { surveys: _vm.surveys },
                          on: { reload_surveys: _vm.reloadSurveys }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 q-mt-md" },
                  [_c("badges", { attrs: { badges: _vm.badges, home: true } })],
                  1
                )
              ])
            ]),
            _c("div", { staticClass: "col-4" }, [
              _c("div", { staticClass: "row gutter-sm" }, [
                _vm.has_news
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("news-feed", {
                          attrs: {
                            news_loaded: _vm.news_loaded,
                            news: _vm.news,
                            home: true
                          },
                          on: { openNews: _vm.openNews }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.has_feed
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [_c("activities", { attrs: { qtn_active: 5 } })],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _c(
        "q-modal",
        {
          attrs: { "content-css": { minWidth: "100vw", minHeight: "100vh" } },
          model: {
            value: _vm.show_all_ranking,
            callback: function($$v) {
              _vm.show_all_ranking = $$v
            },
            expression: "show_all_ranking"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_all_ranking = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("ranking")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("all-ranking", {
                    attrs: {
                      user_firebase_document_ranking_areas:
                        _vm.user_firebase_document_ranking_areas,
                      user_firebase_document: _vm.user_firebase_document
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("modal-news", {
        attrs: { show_modal: _vm.show_news, id: _vm.single_news.id },
        on: { hideModalNews: _vm.hideModalNews }
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_statement,
            callback: function($$v) {
              _vm.show_statement = $$v
            },
            expression: "show_statement"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_statement = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("points_statement")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("points-statemenet", {
                    attrs: { score_statement: _vm.user_score_statement }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }